import React, { useState } from 'react';
import { Backdrop, Fade, LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';

const audit = [
    {
        user: 'ADMIN',
        date: '02-01-2021',
        time: '10:20',
        type: 'Created',
        status: 'Entry',
    },
    {
        user: 'ADMIN',
        date: '02-01-2021',
        time: '10:22',
        type: 'Created',
        status: 'Submit',
    },
    {
        user: 'ADMIN',
        date: '03-01-2021',
        time: '10:00',
        type: 'Created',
        status: 'Recheck',
    },
    {
        user: 'ADMIN',
        date: '04-01-2021',
        time: '18:00',
        type: 'Approved',
        status: 'Approved',
    },
];
export default function AuditLogs({ ticketId }) {
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(false);

    return (
        <>
                <TableContainer component={Paper}>
                <Table className={classes.table} size="small" aria-label="audit logs">
                        <TableHead>
                            <TableRow>
                            <TableCell>User</TableCell>
                            <TableCell>Date</TableCell>
                            <TableCell>Time</TableCell>
                            <TableCell align="right">Status</TableCell>
                            </TableRow>
                        </TableHead>
                            <TableBody>
                        <Fade
                            in={isLoading}
                            style={{
                                transitionDelay: isLoading ? '800ms' : '0ms',
                            }}
                            unmountOnExit
                        >
                            <LinearProgress />
                        </Fade>
                            {audit.map((row) => (
                                <TableRow key={row.status} className={classes.hideLastBorder}>
                                    <TableCell component="td" scope="row">
                                        {row.user}
                                    </TableCell>
                                    <TableCell component="td" scope="row">
                                        {row.date}
                                    </TableCell>
                                    <TableCell component="td" scope="row">
                                        {row.time}
                                    </TableCell>
                                    <TableCell component="td" scope="row" align="right">
                                        {row.status}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
        </>
    );
}
const useStyles = makeStyles(theme => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));

